import { render, staticRenderFns } from "./PunchCompetition.vue?vue&type=template&id=750b5932&scoped=true"
import script from "./PunchCompetition.vue?vue&type=script&lang=js"
export * from "./PunchCompetition.vue?vue&type=script&lang=js"
import style0 from "./PunchCompetition.vue?vue&type=style&index=0&id=750b5932&prod&scoped=true&lang=css"
import style1 from "./PunchCompetition.vue?vue&type=style&index=1&id=750b5932&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b5932",
  null
  
)

export default component.exports